import { render, staticRenderFns } from "./EventPanelSuper.vue?vue&type=template&id=61858fea&scoped=true"
import script from "./EventPanelSuper.vue?vue&type=script&lang=js"
export * from "./EventPanelSuper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61858fea",
  null
  
)

export default component.exports